import { getPlatform } from 'utils/platform'

export const directToMobileScreenViewed = {
  event: 'screen_viewed',
  object_name: 'directToMobile',
  screen: 'directToMobile',
  screen_name: 'directToMobile',
  platform: getPlatform(),
}
